import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";
import {Injectable} from "@angular/core";
import {AccessControlService} from "../services/access-control.service";
import {Observable, Subscriber} from "rxjs";

@Injectable()
export class AccessControlGuard implements CanActivate {

  constructor(private accessControlService: AccessControlService,
              private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const accessName = this.accessControlService.getAccessNameFromRoute(route);
    const ownUserAccess = this.accessControlService.checkOwnUserAccess(route, state);
    const lineId = this.accessControlService.getLineIdFromRoute(route, state);

    return new Observable<boolean>((subscriber) => {
      this.accessControlService.initializeScreenAccess(accessName).subscribe((screenAccessInitialized) => {
        this.accessControlService.initializeLineData(lineId, accessName).subscribe((lineDataInitialized) => {
          if(ownUserAccess) {
            console.log(`Grant access because of own-user-access`);
            this.grantAccess(subscriber);
          }
          else {
            if(!screenAccessInitialized || !lineDataInitialized) {
              console.log(`Failed to initialize screen access data`);
              this.denyAccess(subscriber);
            }
            else {
              this.checkAccess(accessName, subscriber);
            }
          }
        });
      });
    });
  }

  private checkAccess(accessName: string, subscriber: Subscriber<boolean>) {
    const hasAccess = this.accessControlService.checkUserAccess(accessName);

    if(hasAccess) {
      this.grantAccess(subscriber);
    }
    else {
      this.denyAccess(subscriber);
    }
  }

  private grantAccess(subscriber: Subscriber<boolean>) {
    subscriber.next(true);
    subscriber.complete();
  }

  private denyAccess(subscriber: Subscriber<boolean>) {
    this.router.navigate(['/access-denied']);
    subscriber.next(false);
    subscriber.complete();
  }
}
